import { render } from "./Number.vue?vue&type=template&id=1ce83d56&scoped=true"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"

import "./Number.vue?vue&type=style&index=0&id=1ce83d56&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce83d56"]])

export default __exports__